export default "__VITE_ASSET__427b2cee__"